import Backbone from 'backbone'
import _ from 'lodash'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import DataType from 'scoreboard/datasets/model/data-type'
const { TEXT } = DataType
import Dataset from 'scoreboard/datasets/model/dataset'
const { isVisibleLinkedFieldIdentifier, isTotal } = Dataset
import SummaryType from 'scoreboard/datasets/model/summary-type'
const { SUM } = SummaryType

/**
 * Metadata about a dataset table widget, a table on the datasets overview, or
 * a single value on the datasets overview (e.g. average age).
 * For a full list of available properties, see DatasetTable.kt
 *
 * @property {Boolean} isDefaultAggregations true if these are the default
 * 					dataset aggregations that get created when the table is initially created
 * @property {Boolean} sortable true if the table can be sorted
 * @property {'row'|'value'|'column'|'value-and-row'|'value-and-column'|'everything'} percentageOf
 * @property {String} summaryType
 * @property {Number} groupCalendarId
 * @property {Number} breakdownCalendarId
 */
const DatasetTable = Backbone.Model.extend(/** @lends DatasetTable.prototype */ {

	/**
	 * @constructs
	 *
	 * @param {Object} options
	 * @param {Dataset} options.dataset
	 * @param {Number} options.fieldIdentifier
	 */
	initialize: function(attributes, options = {}) {
		const fieldIdentifier = options.fieldIdentifier
		const dataset = options.dataset

		if (fieldIdentifier) {
			this.set('fieldId', fieldIdentifier)
			if (isVisibleLinkedFieldIdentifier(fieldIdentifier)) {
				const visibleLinkedFieldId = -1 * fieldIdentifier
				this.set({ visibleLinkedFieldId })
				const fieldId = dataset.visibleLinkedFieldsById[
					visibleLinkedFieldId].fieldId
				this.set({ fieldId })
			}
		}

		if (dataset) {
			let fieldId = this.get('fieldId')
			this.set({
				summaryType: DatasetTable.getSummaryType(dataset, fieldId),
				datasetId: dataset.id
			})
		}
	}

}, {

	getSummaryType: function (dataset, fieldId) {
		let summaryType

		if (isTotal(fieldId)) {
			summaryType = SUM
		} else {
			let field = dataset.combinedFieldsById[fieldId]
			let underlyingField = dataset.getUnderlyingField(field)
			if (isNumericDataType(underlyingField?.dataType)) {
				if (_.isEmpty(underlyingField.ranges)) {
					summaryType = underlyingField.aggregationType
				} else {
					summaryType = 'range'
				}
			}

			if (underlyingField && underlyingField.dataType == TEXT &&
				!_.isEmpty(underlyingField.ranges)) {
				summaryType = 'range'
			}
		}
		return summaryType
	}

})

export default DatasetTable

DatasetTable.__filename__ = 'datasets/model/dataset-table.js'
